var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, makeObservable, action } from "mobx";
import { LeterPermissionType, Letr } from "@@/Letr";
// import { TStore } from "../TagsStore";
import { Tag, TagCategory } from "@@/Tags";
import { ChatIconCh } from "@@/Icons";
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { DEFAULT_TAGS } from "@@/Defaults";
import { LetrEditrequestType, LetrRequestType } from "@/share/Letr";
import { AdminAddMemberState } from "./AdminAddMemberState";
import { AddMemberDialogState } from "@/app/uistore/AddMemberDialogState";
import { LetrLinkEmailDialogState } from "@/app/UIComponents/LinkEmail";
export class LetrUser {
    constructor() {
        this.id = "";
        this.name = "";
    }
}
export class AdminLetrViewStore {
    constructor() {
        this.showPassword = false;
        this.showMasterKey = false;
        this.password = "";
        this.masterkey = "";
        this.error = false;
        this.errormsg = "";
        this.working = false;
        this.revealed = false;
        this.userMap = new Map();
        this.selectedUserId = "";
        this.loadingletrs = false;
        this.activeview = "project";
        this.letrsMap = new Map();
        this.loadingTagsStatus = 0;
        this.tagsMap = new Map();
        this.selectedTag = "";
        this.selectedLetrid = "";
        this.loadingletrdetail = false;
        this.loadingconnectdetail = false;
        this.letrmemberdetail = [];
        this.removingmemeber = new Set();
        // @observable public addmemstate: AddMemberState = new AddMemberState();
        this.connectmemberhint = "";
        this.connectmemberpassword = "";
        this.showconnectpassword = false;
        this.updatingconnect = false;
        this.selectedletrconnect = "";
        this.ChatTagID = "__chat__";
        this.ctag = new Tag(this.ChatTagID, 'Direct Messages', false, TagCategory.managing, ChatIconCh, false);
        this.includeDocumentsInExport = false;
        this.showusersmenu = false;
        this.activeviewer = "chat";
        this.addmemstate = new AdminAddMemberState();
        this.activeuserid = "";
        this.roles = new Map();
        this.editmember = new Set();
        this.memebrids = new Set();
        this.editpermission = new Map();
        this.savingmems = new Set();
        this.addmemberdialogstate = new AddMemberDialogState();
        this.allowSelEdit = false;
        this.letrlinks = new Map();
        this.deletelinks = new Set();
        this.downloadinglinks = false;
        this.showletrlinks = false;
        this.editlinkpermission = new Map();
        this.editlink = new Set();
        this.savinglinks = new Set();
        this.emaillinkid = "";
        this.linkemail = "";
        this.letremaildialogstate = new LetrLinkEmailDialogState();
        this.removing = false;
        this.adding = false;
        makeObservable(this);
        // AEvent.addSubscriberForTags((tags) => {
        //     tags.forEach(t => this.setTag(t));
        // });
        APPEvent.addSubscriberForAdminTagChanged((tag) => this.setSelectedTag(tag.id));
        APPEvent.addSubscriberForLetrUserChanged((id) => this.setSelectedUserId(id));
        APPEvent.addSubscriberForAdminLetrChanged((letr) => this.letrChanged(letr));
        // AEvent.addSubscriberForTags((tags) => {
        //     tags.forEach(t => this.setTag(t));
        // });
        APPEvent.addSubscriberForAdminLoadUserTagsRes((tags) => {
            tags.forEach(t => this.setTag(t));
            this.setLoadingTags(2);
            this.letrmemberdetail = [];
            this.activeletrdetail = undefined;
            this.letrconnectres = undefined;
            this.selectedletrconnect = "";
            this.setConnectMemberPassword("");
            this.setConnectMemberHint("");
        });
        APPEvent.addSubscriberForAdminLetrsResponse((res) => {
            if (res.letrid === this.selectedLetrid && res.letrdetail !== undefined) {
                this.activeletrdetail = res.letrdetail;
                this.letrmemberdetail = res.letrdetail.memberDetails;
            }
            this.editmember.clear();
            this.editpermission.clear();
            this.savingmems.clear();
            this.setLoadingLetrDetail(false);
            this.addmemstate.setOpen(false);
        });
        // APPEvent.addSubscriberForAdminEditLetrMember((res) => {
        //     if (res.letrid === this.selectedLetrid && res.detail !== undefined) {
        //         this.activeletrdetail = res.detail;
        //         this.letrmemberdetail = res.detail.memberDetails;
        //         this.addmemstate.setOpen(false);
        //     }
        // });
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.resetLetr();
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            this.resetLetr();
        });
        APPEvent.addSubcriberForAdminGetRole((role) => {
            var _a;
            for (const ro of role) {
                if (ro.letrid === ((_a = this.selectedLetr) === null || _a === void 0 ? void 0 : _a.id)) {
                    this.setRole(ro);
                }
            }
            // we should check and update permission here again
            // if(this.loadingroles && this.activeletrdetail) {
            //     this.setMyPermission(this.activeletrdetail.mypermission.permission);
            //     this.setMyCaps(this.activeletrdetail.mypermission);
            //     this.loadedLetrContent();
            //     if(this.letrres) {
            //         APPEvent.publishLocalLetrDetail(this.letrres);
            //     }
            // }
            // this.loadingroles = false;
        });
        APPEvent.addSubscriberForAdminGetLetrlink((res) => {
            if (res.userid === this.activeuserid && res.letrid === this.selectedLetrid) {
                this.resetLink();
                res.links.forEach((link) => this.setLink(link));
                this.setDownloadingLinks(false);
            }
        });
        APPEvent.addSubscriberForAdminEditLetrMember((res) => {
            var _a, _b, _c;
            if (res.userid === this.activeuserid && res.letrid === this.selectedLetrid) {
                if (res.type === LetrEditrequestType.update) {
                    if (!res.detail) {
                        APPEvent.publishApperror("Sorry, failed to update the role.");
                    }
                    else {
                        const perms = new Map();
                        res.detail.memberDetails.forEach((mem) => perms.set(mem.id, mem.roleid));
                        this.updateMemeberPerms(((_a = res.memberid) !== null && _a !== void 0 ? _a : []).map((memb) => memb.userid), perms);
                    }
                    for (const mem of (_b = res.memberid) !== null && _b !== void 0 ? _b : []) {
                        this.removeEditMemberSave(mem.userid);
                        this.removeEditMember(mem.userid);
                    }
                    return;
                }
                if (res.type === LetrEditrequestType.updatelink) {
                    if (!res.links) {
                        APPEvent.publishApperror("Sorry, failed to update the role for links.");
                    }
                    else {
                        const links = res.links;
                        this.resetLink();
                        links.forEach((link) => this.setLink(link));
                    }
                    for (const mem of (_c = res.memberid) !== null && _c !== void 0 ? _c : []) {
                        this.removeEditLinkSave(mem.userid);
                        this.removeEditLink(mem.userid);
                    }
                    return;
                }
                if (res.detail !== undefined) {
                    this.setLetrDetail(res.detail);
                }
                this.setAdding(false);
                this.setRemoving(false);
                APPEvent.publishCloseWorkingDialog("close");
                this.setSelectedGroup(undefined);
                this.addmemberdialogstate.setOpen(false);
                this.addmemberdialogstate.setAdding(false);
            }
        });
        APPEvent.addSubscriberForAdminLetrDeleteRes((res) => {
            if (res.result) {
                this.removeLetr(res.letrid);
                this.resetLetr();
                APPEvent.publishCloseWorkingDialog("clode");
            }
            else {
                APPEvent.publishCloseWorkingDialog("clode");
                APPEvent.publishApperror("Sorry, failed to delete this letr. Please try again or contact support if this issue persist.");
            }
        });
        APPEvent.addSubscriberForAdminDeleteLetrlink((res) => {
            if (res.userid === this.activeuserid && res.letrid === this.selectedLetrid && this.deletelinks.has(res.id)) {
                if (res.ok) {
                    this.removeLinkFromList(res.id);
                }
                else {
                    this.removeLinkFromDeleteList(res.id);
                    // lets alert this now
                    const link = this.letrlinks.get(res.id);
                    if (link !== undefined) {
                        APPEvent.publishApperror("Sorry, failed to delete " + link.name);
                    }
                }
            }
        });
    }
    setRemoving(remov) {
        this.removing = remov;
    }
    setAdding(add) {
        this.adding = add;
    }
    removeLetr(id) {
        this.letrsMap.delete(id);
    }
    setLetrDetail(letrDetail) {
        this.activeletrdetail = letrDetail;
        this.letrmemberdetail = letrDetail.memberDetails;
        letrDetail.memberDetails.forEach((m) => this.memebrids.add(m.id));
    }
    updateMemeberPerms(mem, perms) {
        var _a, _b, _c;
        for (const member of (_b = (_a = this.activeletrdetail) === null || _a === void 0 ? void 0 : _a.memberDetails) !== null && _b !== void 0 ? _b : []) {
            if (mem.indexOf(member.id) !== -1 && perms.has(member.id)) {
                member.roleid = (_c = perms.get(member.id)) !== null && _c !== void 0 ? _c : '';
            }
        }
        if (this.activeletrdetail !== undefined) {
            this.activeletrdetail = this.activeletrdetail;
            this.letrmemberdetail = this.activeletrdetail.memberDetails;
        }
    }
    addRemvingMemebr(id) {
        this.removingmemeber.add(id);
    }
    addEditLinkPerm(mid, rid) {
        this.editlinkpermission.set(mid, rid);
    }
    removeEditLinkPerm(mid) {
        this.editlinkpermission.delete(mid);
    }
    addEditLink(mid) {
        this.editlink.add(mid);
    }
    removeEditLink(mid) {
        this.editlink.delete(mid);
    }
    addEditLinkSave(mid) {
        this.savinglinks.add(mid);
    }
    removeEditLinkSave(mid) {
        this.savinglinks.delete(mid);
    }
    removeLinkFromDeleteList(id) {
        this.deletelinks.delete(id);
    }
    removeLinkFromList(id) {
        this.letrlinks.delete(id);
        this.removeLinkFromDeleteList(id);
    }
    deleteLetrLink(id) {
        this.deletelinks.add(id);
        const req = {
            letrid: this.selectedLetrid,
            id: id,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admindeleteletrlink", req);
    }
    sendLetrEmailLink(name, email, id) {
        const req = {
            email: email,
            linkid: id,
            name: name,
            letrid: this.selectedLetrid
        };
        this.emaillinkid = id;
        this.linkemail = email;
        Apphandler.sendMessage("sendlinkemail", req);
    }
    updateLetrLink(id) {
        const perm = this.editlinkpermission.get(id);
        if (!perm || !this.selectedLetrid) {
            return;
        }
        this.addEditLinkSave(id);
        const req = {
            type: LetrEditrequestType.updatelink,
            memberid: [{ userid: id, permission: LeterPermissionType.View, roleid: perm }],
            letrid: this.selectedLetrid,
            isConnect: false,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admineditletrmember", req);
    }
    getLetrMemberName(id) {
        const mem = this.letrmemberdetail.filter((fil) => fil.id === id);
        if (mem !== undefined && mem.length > 0) {
            return mem[0].name;
        }
        return "Member name unknown";
    }
    resetLink() {
        this.letrlinks.clear();
        this.deletelinks.clear();
    }
    setLink(link) {
        this.letrlinks.set(link.id, link);
    }
    getLetrLinks() {
        if (this.downloadinglinks) {
            return;
        }
        this.setDownloadingLinks(true);
        const req = {
            letrid: this.selectedLetrid,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admingetletrlink", req);
    }
    setDownloadingLinks(downloading) {
        this.downloadinglinks = downloading;
    }
    setShowLetrLinks(show) {
        this.showletrlinks = show;
    }
    setRole(role) {
        this.roles.set(role.id, role);
    }
    getRoles() {
        return Array.from(this.roles.values()).slice().sort((r1, r2) => {
            if (r1.id.endsWith("_admin"))
                return -1;
            if (r2.id.endsWith("_admin"))
                return 1;
            if (r1.id.endsWith("_editor"))
                return -1;
            if (r2.id.endsWith("_editor"))
                return 1;
            if (r1.id.endsWith("_viewer"))
                return -1;
            if (r2.id.endsWith("_viewer"))
                return 1;
            return r1.name.toLowerCase().localeCompare(r2.name.toLowerCase());
        });
    }
    removeEditMember(mid) {
        this.editmember.delete(mid);
    }
    addEditmemebrSave(mid) {
        this.savingmems.add(mid);
    }
    removeEditMemberSave(mid) {
        this.savingmems.delete(mid);
    }
    addEditmemebrPerm(mid, rid) {
        this.editpermission.set(mid, rid);
    }
    removeEditMemberPerm(mid) {
        this.editpermission.delete(mid);
    }
    addEditmemebr(mid) {
        this.editmember.add(mid);
    }
    updateLetrMember(id) {
        const perm = this.editpermission.get(id);
        if (!perm || this.selectedLetr === undefined) {
            return;
        }
        this.addEditmemebrSave(id);
        const req = {
            type: LetrEditrequestType.update,
            letrid: this.selectedLetrid,
            memberid: [{ userid: id, permission: LeterPermissionType.View, roleid: perm }],
            isConnect: false,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admineditletrmember", req);
    }
    setSelectedGroup(grp) {
        this.selectedGroup = grp;
        // this.setShowMenu(false);
    }
    setAllowEdit(allow) {
        this.allowSelEdit = allow;
    }
    gotDeleteRes(res) {
        if (res.letrid === this.selectedLetrid && res.result !== undefined) {
            this.setSelectedLetr("");
            this.selectedLetr = undefined;
            this.letrsMap.delete(this.selectedLetrid);
            this.addmemstate.setOpen(false);
        }
    }
    setActiveViewer(viewer) {
        this.activeviewer = viewer;
    }
    setIncludeDocumentsInExport(inc) {
        this.includeDocumentsInExport = inc;
    }
    setShowUsersMenu(show) {
        this.showusersmenu = show;
    }
    letrChanged(letr) {
        this.selectedLetr = letr;
        this.setSelectedLetr(letr.id);
        // rstore.repliesStore.reset();
        this.setActiveView("project");
        this.setActiveViewer("project");
    }
    async addUserToLetr(perms) {
        this.setAdding(true);
        const req = {
            type: LetrEditrequestType.Add,
            letrid: this.selectedLetrid,
            memberid: perms,
            isConnect: false,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admineditletrmember", req);
    }
    async removeLetrMember(mem, isConnect) {
        this.setRemoving(true);
        const req = {
            type: LetrEditrequestType.Delete,
            letrid: this.selectedLetrid,
            memberid: [{ userid: mem.id, permission: LeterPermissionType.View, roleid: '' }],
            isConnect: false,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admineditletrmember", req);
    }
    async purgeActiveLetr() {
        if (!this.selectedLetrid) {
            return;
        }
        const req = {
            letrid: this.selectedLetrid,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admindeleteletr", req);
    }
    setLoadingLetrDetail(det) {
        this.loadingletrdetail = det;
    }
    setLoadingLetrConnectDetail(det) {
        this.loadingconnectdetail = det;
    }
    async getLetrDetail() {
        if (this.letrmemberdetail.length === 0) {
            this.setLoadingLetrDetail(true);
            this.fetchLetrDetail();
            this.setLoadingLetrDetail(false);
        }
        return this.letrmemberdetail;
    }
    async fetchLetrDetail() {
        const req = {
            type: LetrRequestType.FetchDetail,
            letrid: this.selectedLetrid,
            userid: this.selectedUserId
        };
        if (this.selectedLetrid) {
            this.setLoadingLetr;
            Apphandler.sendMessage("adminletrdetail", req);
            this.getLetrLinks();
        }
        // const det = await LStore.getLetrDetail(this.selectedUserId, this.selectedLetrid);
        // this.activeletrdetail = det;
        // if (det !== undefined) {
        //     this.letrmemberdetail = det.memberDetails;
        // }
    }
    getSortedTags() {
        const tags = [];
        tags.push(DEFAULT_TAGS.allletrs);
        tags.push(DEFAULT_TAGS.atag);
        return tags;
    }
    getChildrenOfTag(tagid) {
        return this.getSortedTags().filter(t => t.parent === tagid).sort(this.sortTagByname);
    }
    sortTagByname(t1, t2) {
        return t1.name.toLowerCase().localeCompare(t2.name.toLowerCase());
    }
    sortTag(t1, t2) {
        return t1.sortname.localeCompare(t2.sortname);
    }
    getTopLevelTag() {
        return this.getSortedTags().filter(t => !t.parent);
    }
    setTag(tag) {
        this.tagsMap.set(tag.id, tag);
    }
    setActiveView(view) {
        this.activeview = view;
        if (view === 'info') {
            this.getLetrDetail();
            const req = {
                letrid: this.selectedLetrid,
                userid: this.selectedUserId
            };
            Apphandler.sendMessage("admingetroles", req);
        }
    }
    setShowConnectPassword(show) {
        this.showconnectpassword = show;
    }
    setLoadingLetr(loading) {
        this.loadingletrs = loading;
    }
    setLetrs(letrs) {
        letrs.forEach((letr) => {
            this.letrsMap.set(letr.id, letr);
        });
    }
    getLetrs() {
        return Array.from(this.letrsMap.values());
    }
    async setSelectedUserId(userid) {
        if (this.selectedUserId !== userid) {
            this.selectedUserId = userid;
            this.letrsMap = new Map();
            this.tagsMap = new Map();
            this.setActiveView("chat");
            this.selectedTag = "";
            this.setLoadingTags(1);
            // const dtags = TStore.getDefaulTags();
            const dtags = DEFAULT_TAGS.DefaultTags;
            for (const tag of dtags) {
                this.setTag(tag);
            }
            const req = {
                userid: userid
            };
            // Apphandler.sendMessage("adminloadusertags", req);
            // await TStore.loadUserTags(this.selectedUserId);
        }
    }
    getNameForLetrUser(id) {
        if (this.letrmemberdetail.length > 0) {
            for (const m of this.letrmemberdetail) {
                if (m.id === id) {
                    return m.name + "(" + m.orgname + ")";
                }
            }
        }
        return "Unknown";
    }
    setConnectMemberPassword(pwd) {
        this.connectmemberpassword = pwd;
    }
    async storeConnectPassword() {
        if (this.connectmemberhint === "" || this.connectmemberpassword === "" || this.connectmemberpassword.length < 8) {
            return;
        }
        this.updatingconnect = true;
        // const res = await LStore.storeConnectPassword(this.selectedUserId, this.selectedLetrid, 
        // this.selectedletrconnect, this.connectmemberhint, this.connectmemberpassword);
        this.updatingconnect = false;
        // return res;
    }
    setConnectMemberHint(hint) {
        this.connectmemberhint = hint;
    }
    async loadConnectDetail(mem) {
        this.setLoadingLetrConnectDetail(true);
        this.selectedletrconnect = mem.id;
        // const res = await LStore.getLetrConnectDetail(this.selectedUserId, this.selectedLetrid, mem.id);
        // this.letrconnectres = res;
        // this.setConnectMemberPassword(res?.userpassword??"");
        // this.setConnectMemberHint(res?.hint??"");
        this.setLoadingLetrConnectDetail(false);
    }
    setLoadingTags(status) {
        this.loadingTagsStatus = status;
    }
    setSelectedTag(tagid) {
        this.selectedTag = tagid;
        this.resetLetr();
    }
    setSelectedLetr(letrid) {
        this.selectedLetrid = letrid;
        this.letrmemberdetail = [];
        this.activeletrdetail = undefined;
        this.setActiveView("chat");
        this.letrconnectres = undefined;
        this.selectedletrconnect = "";
        this.setConnectMemberPassword("");
        this.setConnectMemberHint("");
    }
    getSelectedLetr() {
        return this.selectedLetr;
    }
    setWorking(work) {
        this.working = work;
    }
    setRevealed(rev) {
        this.revealed = rev;
    }
    setError(error) {
        this.error = error;
    }
    setErrorMsg(emsg) {
        this.errormsg = emsg;
    }
    toggleShowPassword() {
        this.showPassword = !this.showPassword;
    }
    toggleShowMasterKey() {
        this.showMasterKey = !this.showMasterKey;
    }
    setPassword(password) {
        this.password = password;
    }
    setMasterKey(mk) {
        this.masterkey = mk;
    }
    get users() {
        return Array.from(this.userMap.values());
    }
    resetLetr() {
        this.letrsMap = new Map();
        this.setActiveView("chat");
        this.removingmemeber.clear();
        this.letrmemberdetail = [];
        this.activeletrdetail = undefined;
        this.letrconnectres = undefined;
        this.selectedletrconnect = "";
        this.setConnectMemberPassword("");
        this.setConnectMemberHint("");
        this.setLoadingLetr(false);
        this.setLoadingLetrDetail(false);
        this.roles = new Map();
    }
    convertUserToUserView(user) {
        const ret = new LetrUser();
        ret.id = user.id;
        ret.name = user.name;
        return ret;
    }
}
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminLetrViewStore.prototype, "showPassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminLetrViewStore.prototype, "showMasterKey", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminLetrViewStore.prototype, "password", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminLetrViewStore.prototype, "masterkey", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminLetrViewStore.prototype, "error", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminLetrViewStore.prototype, "errormsg", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminLetrViewStore.prototype, "working", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminLetrViewStore.prototype, "revealed", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminLetrViewStore.prototype, "userMap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "selectedUserId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "loadingletrs", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminLetrViewStore.prototype, "activeview", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminLetrViewStore.prototype, "letrsMap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "loadingTagsStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminLetrViewStore.prototype, "tagsMap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "selectedTag", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "selectedLetrid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "loadingletrdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "loadingconnectdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminLetrViewStore.prototype, "letrmemberdetail", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminLetrViewStore.prototype, "removingmemeber", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "connectmemberhint", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "connectmemberpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "showconnectpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "updatingconnect", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "selectedletrconnect", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminLetrViewStore.prototype, "includeDocumentsInExport", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "selectedLetr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "letrconnectres", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminLetrViewStore.prototype, "showusersmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminLetrViewStore.prototype, "activeviewer", void 0);
__decorate([
    observable,
    __metadata("design:type", AdminAddMemberState)
], AdminLetrViewStore.prototype, "addmemstate", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminLetrViewStore.prototype, "roles", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminLetrViewStore.prototype, "editmember", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminLetrViewStore.prototype, "editpermission", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminLetrViewStore.prototype, "savingmems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "selectedGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminLetrViewStore.prototype, "allowSelEdit", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminLetrViewStore.prototype, "letrlinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminLetrViewStore.prototype, "deletelinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "downloadinglinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "showletrlinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminLetrViewStore.prototype, "editlinkpermission", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminLetrViewStore.prototype, "editlink", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminLetrViewStore.prototype, "savinglinks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "removing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminLetrViewStore.prototype, "adding", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setRemoving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setAdding", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setLetrDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Map]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "updateMemeberPerms", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "addRemvingMemebr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "addEditLinkPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeEditLinkPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "addEditLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeEditLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "addEditLinkSave", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeEditLinkSave", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeLinkFromDeleteList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeLinkFromList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "deleteLetrLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "resetLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setDownloadingLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setShowLetrLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeEditMember", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "addEditmemebrSave", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeEditMemberSave", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "addEditmemebrPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "removeEditMemberPerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "addEditmemebr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setSelectedGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setAllowEdit", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setActiveViewer", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setIncludeDocumentsInExport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setShowUsersMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Letr]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "letrChanged", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Promise)
], AdminLetrViewStore.prototype, "addUserToLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Boolean]),
    __metadata("design:returntype", Promise)
], AdminLetrViewStore.prototype, "removeLetrMember", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AdminLetrViewStore.prototype, "purgeActiveLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setLoadingLetrDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setLoadingLetrConnectDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AdminLetrViewStore.prototype, "getLetrDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AdminLetrViewStore.prototype, "fetchLetrDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Tag]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setShowConnectPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setLoadingLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setLetrs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], AdminLetrViewStore.prototype, "setSelectedUserId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setConnectMemberPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AdminLetrViewStore.prototype, "storeConnectPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setConnectMemberHint", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], AdminLetrViewStore.prototype, "loadConnectDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setLoadingTags", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setSelectedTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setSelectedLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setWorking", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setRevealed", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setErrorMsg", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "toggleShowPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "toggleShowMasterKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "setMasterKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminLetrViewStore.prototype, "resetLetr", null);
